import React from 'react';

import AwesomeIcon from 'icons/awesome.svg';
import { useTranslation } from 'react-i18next';

import InfoPill from 'components/application/pills/InfoPill';

export default function NewInfoPill() {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <InfoPill
      className='tw-bg-lime-050 tw-text-lime-700 [&_svg_path]:tw-fill-lime-700'
      icon={<AwesomeIcon className='tw-m-0 tw-mr-[6px]' />}
      text={
        <div className='tw-text-xs tw-tracking-wide'>{i18nTShared('new')}</div>
      }
    />
  );
}
